import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import FilterPanel from "../../../sharedComponents/filterPanel";
import DeclineFoodPanel from "./add/declineFoodPanel";
import { togglePreloader, getPatientFoodDetails, resetField } from "../../../store/actions";
import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import { foodTypeList, servingsList } from "../../../constants/recipeConstants";
import "./FoodDatabase.scss";

const FoodApprovalDetails = ({ foodList, foodDetails, match, getPatientFoodDetails, history, isAdmin, resetField }) => {
	const foodId = (match && match.params && match.params.id) || null;

	const [food, setFood] = useState([]);

	useEffect(() => {
		getPatientFoodDetails(`${foodId}/approve_food`);
	}, [foodId, getPatientFoodDetails]);

	useEffect(() => {
		setFood([...foodList]);
	}, [foodList]);

	const { name, source, long_desc, nut_data } = foodDetails;

	let [foodDetailsColumns] = useState([]);
	let [foodDetailsData] = useState([]);

	if (nut_data) {
		const columnHeader = nut_data[0];
		foodDetailsColumns = Object.keys(columnHeader).map((key) => {
			return {
				Header: columnHeader[key],
				accessor: key,
				sortable: false,
			};
		});
		foodDetailsData = nut_data.slice(1);
	}

	useEffect(() => {
		return () => {
			resetField("FoodDatabase.foodApprovalList", {});
		};
	}, [resetField]);

	const renderEditFoodItem = () => {
		history.push(`/nutrition/food-database/approval/${foodId}/edit`);
	};

	const handleBackNavigation = () => {
		history.push(`/nutrition/food-database/approval`);
	};

	const [showDeclineFoodPanel, setShowDeclineFoodPanel] = useState(false);
	const [foodToDecline, setFoodToDecline] = useState(null);

	const declineFood = (foodId) => {
		setShowDeclineFoodPanel(true);
		setFoodToDecline(foodId);
	};
	const onDeclineSuccess = () => {
		setShowDeclineFoodPanel(false);
		food.filter((item) => item.id !== foodToDecline);
	};
	const onDeclineError = () => {
		setShowDeclineFoodPanel(false);
	};

	const renderDeclineFoodPanel = () => {
		return (
			<FilterPanel
				show={showDeclineFoodPanel}
				toggle={() => setShowDeclineFoodPanel(!showDeclineFoodPanel)}
				title="Decline Food"
				closeBtn>
				{foodToDecline && (
					<DeclineFoodPanel
						onUpdate={onDeclineSuccess}
						onError={onDeclineError}
						data={foodToDecline}
						history={history}
					/>
				)}
			</FilterPanel>
		);
	};

	return (
		<section className="page page-food-details">
			<div className="container">
				<div className="d-flex justify-content-between align-items-center mb-2">
					<h3>
						<button
							className="btn btn-primary-dark btn-ghost mr-3"
							onClick={() => {
								handleBackNavigation();
							}}>
							<i className="icon icon-angle-left"></i>
						</button>
						{name ? name : long_desc}
					</h3>
					{isAdmin ? (
						<div>
							<button className="btn btn-primary mr-3" onClick={renderEditFoodItem}>
								<i className="icon icon-add-edit"></i> Edit
							</button>
							<button className="btn btn-primary-dark btn-ghost" onClick={() => declineFood(foodId)}>
								<i className="icon icon-eye"></i> Decline
							</button>
						</div>
					) : null}
				</div>
				<div className="block block-primary p-4">
					{nut_data && foodDetailsColumns && foodDetailsData ? (
						<React.Fragment>
							<PaginatedTable data={foodDetailsData} columns={foodDetailsColumns} pageSize={1000} />
							<p className="mt-4 font-weight-bold">
								Protein Calorie Type :
								{foodDetails && foodDetails.protein_calorie_type
									? foodTypeList.filter((item) => item.id === foodDetails.protein_calorie_type)[0].name
									: "N/A"}
							</p>
							<p className="font-weight-bold">
								Servings Type :
								{foodDetails && foodDetails.servings_type
									? servingsList.filter((item) => item.id === foodDetails.servings_type)[0].name
									: "N/A"}
							</p>
							<p> Nutritional data source: {source ? source : ""} </p>
							<p> Original long name: {long_desc ? long_desc : ""} </p>
						</React.Fragment>
					) : (
						[]
					)}
				</div>
			</div>
			{renderDeclineFoodPanel()}
		</section>
	);
};

const mapStateToProps = (state) => {
	const { FoodDatabase, UI, Auth } = state;
	return {
		foodList: get(FoodDatabase, "foodApprovalList.results", []),
		foodDetails: get(FoodDatabase, "getPatientFoodItem", {}),
		atBottom: UI.atBottom,
		isAdmin: Auth.isAdmin,
	};
};

const mapDispatchToProps = {
	togglePreloader,
	getPatientFoodDetails,
	resetField,
};

export default connect(mapStateToProps, mapDispatchToProps)(FoodApprovalDetails);
